<template>
    <cic-popup
        id="edit_route_plan"
        :title="item.planId ? 'Edit Route Plan' : 'New Route Plan'"
        :saveable="editing"
        @blur="$emit('blur')"
        @input="$emit('input')"
    >
        <EditRoutePlanInner
            :editing="editing"
            :item="item"
            @change="(field, val) => $emit('change', field, val)"
            @changeList="(val) => $emit('changeList', val)"
            @openRevisions="$emit('openRevisions')"
        />
    </cic-popup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import EditRoutePlanInner from './EditRoutePlanInner';

    export default {
        name: 'EditRoutePlan',
        components: {
            CicPopup,
            EditRoutePlanInner,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'change', 'changeList', 'input', 'openRevisions'],
        data() {
            return {
                editing: false,
            };
        },
        created() {
            this.editing = !this.item.planId || this.$store.hasRight('EDIT_ROUTE_PLANS');
        },
    };
</script>
